import {
  LayoutDashboard,
  ShoppingCart,
  Truck,
  Boxes,
  RotateCcw,
  Building2,
  Store,
  Users,
  Headset,
  ReceiptText,
  History,
  Settings,
  Warehouse,
} from "lucide-react";

// Primary sidebar navigation. `key` doubles as the module identifier used by
// the permission architecture.
export const NAV_ITEMS = [
  { key: "dashboard", label: "Dashboard", to: "/dashboard", icon: LayoutDashboard },
  { key: "orders", label: "Orders", to: "/orders", icon: ShoppingCart },
  { key: "inbound", label: "Inbound", to: "/inbound", icon: Truck },
  { key: "inventory", label: "Inventory", to: "/inventory", icon: Boxes },
  { key: "returns", label: "Returns", to: "/returns", icon: RotateCcw },
  { key: "warehouses", label: "Warehouses", to: "/warehouses", icon: Warehouse },
  { key: "clients", label: "Clients", to: "/clients", icon: Building2 },
  { key: "stores", label: "Stores", to: "/stores", icon: Store },
  { key: "users", label: "Users", to: "/users", icon: Users },
  { key: "va-agencies", label: "VA Agencies", to: "/va-agencies", icon: Headset },
  { key: "invoicing", label: "Invoicing", to: "/invoicing", icon: ReceiptText },
  { key: "activity-log", label: "Activity Log", to: "/activity-log", icon: History },
  { key: "settings", label: "Settings", to: "/settings", icon: Settings },
];

export const QUICK_CREATE_ITEMS = [
  { key: "order", label: "New Order", icon: ShoppingCart },
  { key: "inbound", label: "New Inbound", icon: Truck },
  { key: "return", label: "New Return", icon: RotateCcw },
  { key: "client", label: "New Client", icon: Building2 },
  { key: "store", label: "New Store", icon: Store },
];
